import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FolderOpen, FolderPlus } from "lucide-react";
import useProcessosMapa, { soDigitos } from "@/hooks/useProcessosMapa";
import AutosTag from "@/components/AutosTag";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Lote 117 (Robson, 24/10/2026) — onde quer que o número do processo apareça, 1 toque nele leva à aba Processos:
// monitorado -> abre o processo; ainda não monitorado -> abre "Cadastrar processo" já com o número.
// O clique não "vaza" para o cartão/linha que contém o número.
// Lote 118: se o número tem VÁRIOS autos monitorados, o toque abre uma lista curta com as etiquetas coloridas.
export default function ProcessoLink({ numero, children, className = "" }) {
  const navigate = useNavigate();
  const mapa = useProcessosMapa();
  const [escolher, setEscolher] = useState(false);
  const d = soDigitos(numero);
  if (d.length !== 20) return <span className={className}>{children ?? numero}</span>;
  const p = mapa?.get(d);
  const varios = (p?.todos?.length || 0) > 1;
  const ir = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (varios) { setEscolher(true); return; }
    navigate(p ? `/processos/${p.processo_id}` : `/processos?novo=${encodeURIComponent(numero)}`);
  };
  const Icone = p ? FolderOpen : FolderPlus;
  return (
    <>
      <button
        type="button"
        data-testid="proc-link"
        data-monitorado={p ? "1" : "0"}
        data-autos={varios ? String(p.todos.length) : "1"}
        onClick={ir}
        onKeyDown={(e) => e.stopPropagation()}
        title={varios ? "Escolher os autos" : p ? "Abrir em Processos" : "Monitorar este processo (cadastrar em Processos)"}
        className={`inline-flex items-baseline gap-1 text-left tabular-nums underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-stone-900 ${className}`}
      >
        <span>{children ?? numero}</span>
        <Icone className={`w-3 h-3 self-center shrink-0 ${p ? "text-gold-600" : "text-stone-400"}`} strokeWidth={1.75} aria-hidden />
      </button>
      {varios && (
        <Dialog open={escolher} onOpenChange={setEscolher}>
          <DialogContent className="max-w-sm" onClick={(e) => e.stopPropagation()} data-testid="proc-link-autos">
            <DialogHeader>
              <DialogTitle className="font-display">Qual dos autos?</DialogTitle>
              <DialogDescription className="tabular-nums break-words">{numero}</DialogDescription>
            </DialogHeader>
            <ul className="space-y-2">
              {p.todos.map((x) => (
                <li key={x.processo_id}>
                  <button
                    type="button"
                    data-testid={`proc-link-autos-${x.processo_id}`}
                    onClick={(e) => { e.stopPropagation(); setEscolher(false); navigate(`/processos/${x.processo_id}`); }}
                    className="w-full min-h-[44px] px-3 rounded-md border border-stone-300 bg-white hover:border-stone-500 flex items-center gap-2 text-left"
                  >
                    <AutosTag autos={x.autos} nome={x.autos_nome} />
                    <span className="text-xs text-stone-500">{x.arquivado ? "arquivado" : "abrir ›"}</span>
                  </button>
                </li>
              ))}
            </ul>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
